import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import camelCase from 'lodash/camelCase';

import states from './states';
import { themes, mapData } from './MapOfNigeria.constants';
import { transformKeys } from './MapOfNigeria.helpers';
import { mapOfNigeria } from './scss/MapOfNigeria.module.scss';

const MapOfNigeria = ({ theme, activeProduct }) => {
  const products = transformKeys(mapData);
  const productName = camelCase(get(activeProduct, 'commodity'));
  const productDataList = get(products, `${productName}.data`, []);
  const stateNames = productDataList.map(p => camelCase(p.state));
  const colors = themes[theme];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="744.24182"
      height="599.92847"
      className={mapOfNigeria}
    >
      {states.map(state => {
        const stateName = camelCase(state.name);
        return (
          <path
            key={stateName}
            id={`NG-${stateName}`}
            title={stateName}
            d={state.definition}
            stroke={colors.stroke}
            strokeWidth="4"
            fill={
              stateNames.includes(stateName)
                ? colors.highlight
                : colors.background
            }
          />
        );
      })}
    </svg>
  );
};

MapOfNigeria.propTypes = {
  theme: PropTypes.oneOf(['dark', 'light']),
  activeProduct: PropTypes.shape({}).isRequired,
};

MapOfNigeria.defaultProps = {
  theme: 'dark',
};

export default MapOfNigeria;
